"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var graphql_tag_1 = require("graphql-tag");
exports.ModalSidebarListingFragment = graphql_tag_1.default(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  fragment ModalSidebarListingFragment on Listing {\n    id\n    title\n    slug\n    condition {\n      displayName\n    }\n    images(input: { transform: \"card_square\" }) {\n      source\n    }\n  }\n"], ["\n  fragment ModalSidebarListingFragment on Listing {\n    id\n    title\n    slug\n    condition {\n      displayName\n    }\n    images(input: { transform: \"card_square\" }) {\n      source\n    }\n  }\n"])));
var templateObject_1;
//# sourceMappingURL=modal_sidebar_listing_operations.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/modal_sidebar_listing_operations.js
// module id = jmNj
// module chunks = 20 21